module.exports = __webpack_public_path__ + "static/media/GRTtrans.19370202.png";